import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import Moment from 'react-moment';
import { styles } from './UpdatedLozengeStyles';

export default class UpdatedLozenge extends Component {
  render() {
    return (
        <div className={css(styles.lozengeWrapper)}>
          <span className={css(styles.lozenge)}>
            Last Updated: <Moment format="h:mma, Do MMM" date={this.props.latest_updated*1000} />
          </span>
        </div>
    );
  }
}
